import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';


import clearBR from "../../../../helpers/utils/clearBR";

export default function template() {
    const {className, isMobile, page, data, toggleModal, style, children, noTitle, itemTitleTag, titleTag} = this.props;

  const items = data.items.map(item => {
    const text = isMobile ? clearBR(this.l10n(item.desc)) : this.l10n(item.desc);
    const ItemTitleTag = itemTitleTag ? itemTitleTag : (!data.title || noTitle) ? 'h2' : 'h3';
    const TitleTag = titleTag || 'h2';

        return (
            <div
                style={style ? style.item.wrapper : null}
                key={text}
                className={`${className}-item items-wrapper-item ${item.index ? item.index : ''}`}
            >
                {item.title ? (
                    <ItemTitleTag
                        style={style ? style.item.title : null}
                        className='item-title'
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(this.l10n(item.title))
                        }}
                    />
                ) : (
                    ''
                )}
                {item.number ? (
                    <div
                        style={style ? style.item.number : null}
                        className='item-number'
                        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.number)}}
                    />
                ) : (
                    ''
                )}
                {item.img ? (
                    <img
                        src={item.img}
                        alt={item.img_name}
                        className={`item-img ${item.img_name}`}
                    />
                ) : (
                    ''
                )}
                <div
                    style={style ? style.item.text : null}
                    onClick={item.toggle ? toggleModal : null}
                    className='item-text'
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text)}}
                />
                {item.button ? (
                    <button
                        className='item-button'
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(this.l10n(item.button))
                        }}
                    ></button>
                ) : (
                    ''
                )}
            </div>
        );
      });


    return (
        <div className={`${page}-wrapper usage-block`} style={style ? style.wrapper : null}>
            {children ? children : ''}
            {noTitle ? (
                ''
            ) : (
                <h2
                    style={style ? style.title : null}
                    className='title'
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(data.title))}}
                />
            )}

            {data.subtitle ? (
                <div
                    className='subtitle'
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(data.subtitle))}}
                />
            ) : (
                ''
            )}
            <div className={`${className} items-wrapper`}>{items}</div>
        </div>
    );
}
